// TODO: Atualizar com os dados reais da Veraz Cosméticos
export const WHATSAPP_NUMBER = '556293139891';
export const CONTACT_PHONE = '+55 62 9313-9891';
export const COMPANY_EMAIL = 'verazbrasil@gmail.com'; // TODO: Email real Veraz
export const LOGO_URL =
  'https://res.cloudinary.com/dmkxyykz9/image/upload/v1774964781/veraz_jhaeep.png';
